import { useState } from "react";
import { ImageOff, Loader2 } from "lucide-react";
import { ImageLightbox } from "../ImageLightbox";
import { useAuthedBlobUrl } from "../../hooks/useAuthedImage";
import { renderImagePath, renderFilename, duckTitle } from "../../lib/api";

export const RENDER_VIEWS = [
  ["front", "Front"],
  ["back", "Back"],
  ["left", "Left"],
  ["right", "Right"],
  ["closeup", "Close-up"],
];

const Chip = ({ c, view, label, rowId, onOpen }) => {
  const { src, error } = useAuthedBlobUrl(renderImagePath(c, view, true));
  return (
    <button
      type="button"
      onClick={onOpen}
      disabled={!src}
      title={label}
      aria-label={`Enlarge the ${label.toLowerCase()} AI render`}
      data-testid={`render-chip-${rowId}-${view}`}
      className="grid place-items-center h-8 w-8 rounded-md overflow-hidden border border-border bg-muted/40 transition-transform duration-200 hover:scale-110 disabled:hover:scale-100"
    >
      {src ? <img src={src} alt={`${label} AI render`} className="h-full w-full object-cover" /> : error ? <ImageOff className="h-3.5 w-3.5 text-muted-foreground" /> : <Loader2 className="h-3.5 w-3.5 animate-spin text-muted-foreground" />}
    </button>
  );
};

// The duck's AI renders as 32 px chips (fetched only once the row is opened), each opening the zoom viewer.
export const RenderChips = ({ c, rowId }) => {
  const [idx, setIdx] = useState(-1);
  const views = RENDER_VIEWS.filter(([v]) => c.render_assets?.[v]);
  if (!views.length) return <p data-testid={`render-chips-none-${rowId}`} className="text-xs text-muted-foreground">No AI renders yet.</p>;
  const images = views.map(([v, label]) => ({ src: renderImagePath(c, v), authed: true, label, filename: renderFilename(c, v) }));
  return (
    <div data-testid={`render-chips-${rowId}`} className="flex gap-1.5 flex-wrap">
      {views.map(([v, label], k) => (
        <Chip key={v} c={c} view={v} label={label} rowId={rowId} onOpen={() => setIdx(k)} />
      ))}
      <ImageLightbox open={idx >= 0} onOpenChange={(o) => !o && setIdx(-1)} images={images} index={Math.max(0, idx)} onIndexChange={setIdx} alt={`${duckTitle(c) || "Duck"} AI render`} />
    </div>
  );
};
